import {SxType} from "@baseTypes/sx/sxTypes";
import {GLASS_SYNC, RADIUS_SYNC} from "@containers/singleVoyage/voyageTemplates/sync/theme";

export const sx: SxType = {
	row: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '4px 14px',
		fontSize: '11px',
		color: 'text.secondary',
	},
	// rendered inside the map container, so it sits over the map like its other controls
	overlay: {
		position: 'absolute',
		left: '10px',
		bottom: '24px',
		zIndex: 1000,
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
		p: '8px 10px',
		borderRadius: RADIUS_SYNC,
		boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
		fontSize: '12px',
		color: 'text.primary',
		pointerEvents: 'none',
		...GLASS_SYNC,
		'.lightTheme &': {
			backgroundColor: 'rgba(255, 255, 255, 0.85)',
		},
	},
	item: {
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
		whiteSpace: 'nowrap',
	},
	line: {
		width: '18px',
		height: '3px',
		borderRadius: '2px',
		flexShrink: 0,
	},
	lineWide: {
		height: '7px',
		opacity: 0.5,
	},
	lineDashed: {
		height: 0,
		borderRadius: 0,
		borderTop: '3px dashed',
	},
	dot: {
		width: '10px',
		height: '10px',
		borderRadius: '50%',
		boxSizing: 'border-box',
		flexShrink: 0,
	},
	dotLarge: {
		width: '14px',
		height: '14px',
	},
}
